<template>
  <div>
    <div class="pgemnt-4">
      <div class="ttBar">
        <span>机构管理</span>
      </div>
      <div class="tabArea">
        <div class="seekArea">
          <el-form label-width="80px" :inline="true" class="demo-form-inline">
            <el-form-item label="上级单位">
              <el-input
                size="small"
                v-model="param.parentname"
                style="width: 200px"
                placeholder="输入关键字查询"></el-input>
            </el-form-item>
            <el-form-item label="机构名称">
              <el-input size="small" v-model="param.name" style="width: 200px" placeholder="输入关键字查询"></el-input>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="batchBackSystem()" size="mini">国家新闻出版署批量退回</el-button>
        </div>
        <el-table
          :data="hidePagin ? tableData : tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
          style="width: 100%">
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column label="上级单位" width="150">
            <template slot-scope="scope">
              <span class="goDeeper">{{ scope.row.parent | transParent }}</span>
            </template>
          </el-table-column>
          <el-table-column label="名称" width="150">
            <template slot-scope="scope">
              <span class="goDeeper">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" width="120">
            <template slot-scope="scope">
              <span class="goDeeper">{{ scope.row.type | translate("level") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="流程" width="180">
            <template slot-scope="scope">
              <span class="goDeeper">{{ scope.row.flowName }}</span
              ><br />
              <span class="goDeeper" style="color: red">{{ scope.row.flowId ? "已初始化" : "" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="书号对应ID" width="100">
            <template slot-scope="scope">
              <span class="goDeeper" v-if="scope.row.level == 3">{{ scope.row.tsorgid }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="操作">
            <!-- <template slot="header" slot-scope="scope">
              <el-button class="newAdd" type="primary" @click="btnTrans('add')" size="mini">添加父级</el-button>
            </template> -->
            <template slot-scope="scope">
              <div style="line-height: 40px; float: left">
                <el-button v-if="scope.row.level != 3" type="primary" @click="btnTrans('add', scope.row)" size="mini"
                  >添加</el-button
                >
                <el-button type="danger" @click="btnTrans('edit', scope.row)" size="mini">编辑</el-button>
                <el-button v-if="scope.row.level != 1" type="warning" @click="btnTrans('remove', scope.row)" size="mini"
                  >删除</el-button
                >
                <el-button v-if="scope.row.level == 3" type="warning" @click="setClaimId(scope.row)" size="mini"
                  >设置书号ID</el-button
                >

                <br v-if="scope.row.level == 3" />
                <span style="color: black; font-weight: bold" v-if="scope.row.level == 3">创建审批流程：</span>
                <el-button v-if="scope.row.level == 3" type="primary" @click="setWorks('1', scope.row)" size="mini"
                  >音像</el-button
                >
                <el-button v-if="scope.row.level == 3" type="primary" @click="setWorks('2', scope.row)" size="mini"
                  >电子</el-button
                >
                <el-button v-if="scope.row.level == 3" type="primary" @click="setWorks('3', scope.row)" size="mini"
                  >连续电子</el-button
                >

                <br v-if="scope.row.level == 3" />
                <span style="color: black; font-weight: bold" v-if="scope.row.level == 3">生成申报资料清单：</span>
                <el-button v-if="scope.row.level == 3" type="primary" @click="setMaterials('1', scope.row)" size="mini"
                  >音像</el-button
                >
                <el-button v-if="scope.row.level == 3" type="primary" @click="setMaterials('2', scope.row)" size="mini"
                  >电子</el-button
                >
                <el-button
                  v-if="scope.row.level == 3"
                  type="primary"
                  @click="setMaterialsLxdz('3', scope.row)"
                  size="mini"
                  >连续电子</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="hidePagin == false"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          layout="total, prev, pager, next"
          :total="tableData.length"
          :page-size="pageSize"
          :page-sizes="sizesArray" />
      </div>

      <el-dialog :title="diaTitle" class="pgemnt-4-dag" :visible.sync="diaForAdd" width="480px" center>
        <table>
          <tr>
            <td class="inpName">
              <div>名称：</div>
            </td>
            <td>
              <div class="inContent">
                <el-input size="medium" v-model="postDats.name"></el-input>
              </div>
            </td>
          </tr>
        </table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="diaForAdd = false" size="small">取 消</el-button>
          <el-button class="inContent" type="primary" @click="goSave()" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="设置书号ID" class="pgemnt-4-dag" :visible.sync="diaForSetTsorgid" width="480px" center>
        <table>
          <tr>
            <td class="inpName">
              <div>名称：</div>
            </td>
            <td>
              <div class="inContent">
                <el-input size="medium" v-model="tsorgid"></el-input>
              </div>
            </td>
          </tr>
        </table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeCliamId()" size="small">取 消</el-button>
          <el-button class="inContent" type="primary" @click="saveClaimId()" size="small">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  menuCreate,
  listOrganization,
  delDot,
  setWorks, // zym.设置流程
  setMaterials, // zym.设置申报资料 - 音像电子
  setMaterialsLxdz, // zym.设置申报资料 - 连续电子
  saveClaimId, // zym.设置图书id
} from "@/api/pgMent/sectMent";
import {
  batchBackSystem, // zym.系统内置国家新闻出版署批量退回
} from "@/api/adminRole/adminRole";

import initPagin from "@/mixins/initPagin";
export default {
  mixins: [initPagin],
  props: {
    hidePagin: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,

      // zym.关键字
      param: {
        parentname: "",
        name: "",
      },
      tableData: [],
      tableAllData: [],

      storeArr: [],
      showArr: [],

      //  弹出层

      diaForAdd: false,

      radio1: "",
      radio2: "",
      diaTitle: "",

      postDats: {
        id: "",
        pId: "",
        name: "",
      },

      diaForSetTsorgid: false,
      tsorgid: "", // zym.图书id
      ydOrganizationId: "", // zym.音电系统id
    };
  },
  watch: {
    tableData(val) {
      if (val) this.total = val.length;
    },
    param: {
      deep: true, //实现深度监听
      handler(v) {
        this.filterTableData();
      },
    },
  },
  filters: {
    translate: function (dat, code, map) {
      if (code == "type") {
        let transMap = ["", "页面", "按钮"];
        return transMap[dat];
      } else if (code == "view") {
        let stateArr = ["", "显示", "不显示"];
        return stateArr[dat];
      } else if (code == "level") {
        let stateArr = ["", "新闻出版署", "省局", "出版单位"];
        return stateArr[dat];
      }
    },
    // zym.处理上级单位
    transParent: function (val) {
      if (val == undefined) {
        return "无";
      }
      return val.name;
    },
  },
  methods: {
    batchBackSystem: function () {
      this.$confirm("确定要批量退回吗？退回的数据已经内置在数据库中，请知晓！！！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          batchBackSystem()
            .then((response) => {
              let tipCode = response.tipCode;
              let tipMessage = response.message || "操作失败";
              if (tipCode == "fail") {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "退回成功！",
                  type: "success",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    setClaimId: function (dat) {
      this.diaForSetTsorgid = true;
      this.tsorgid = dat.tsorgid || "";
      this.ydOrganizationId = dat.id || "";
    },
    closeCliamId: function () {
      this.diaForSetTsorgid = false;
      this.tsorgid = "";
      this.ydOrganizationId = "";
    },
    // zym.设置书号id
    saveClaimId: function () {
      console.log("ydOrganizationId=", this.ydOrganizationId, "  ", this.tsorgid);
      this.$confirm("确定要保存书号系统ID？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          saveClaimId({ id: this.ydOrganizationId, tsorgid: this.tsorgid })
            .then((response) => {
              this.closeCliamId();

              let tipCode = response.tipCode;
              let tipMessage = response.tipMessage || "操作失败";
              if (tipCode == "success") {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "success",
                });

                this.listOrganization();
              } else {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    // zym.设置申报资料
    setMaterials: function (type, dat) {
      let types = ["", "音像", "电子", "连续电子"];
      this.$confirm('确定要初始化 "' + types[type] + '" 类型填报资料吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          setMaterials({ type: type, id: dat.id })
            .then((response) => {
              let tipCode = response.tipCode;
              let tipMessage = response.tipMessage || "操作失败";
              if (tipCode == "success") {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "success",
                });

                this.listOrganization();
              } else {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    // zym.设置申报资料 - 连续电子
    setMaterialsLxdz: function (type, dat) {
      let types = ["", "音像", "电子", "连续电子"];
      this.$confirm('确定要初始化 "' + types[type] + '" 类型填报资料吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          setMaterialsLxdz({ type: type, id: dat.id })
            .then((response) => {
              let tipCode = response.tipCode;
              let tipMessage = response.tipMessage || "操作失败";
              if (tipCode == "success") {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "success",
                });

                this.listOrganization();
              } else {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },

    setWorks: function (type, dat) {
      let types = ["", "音像", "电子", "连续电子"];
      this.$confirm('确定要初始化 "' + types[type] + '" 类型审批流程吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          setWorks({ type: type, id: dat.id })
            .then((response) => {
              let tipCode = response.tipCode;
              let tipMessage = response.tipMessage || "操作失败";
              if (tipCode == "success") {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "success",
                });

                this.listOrganization();
              } else {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    isEmpty: function (val) {
      if (val == undefined || val == "") {
        return true;
      }
      return false;
    },
    goDeeper: function (dats) {
      // console.log(dats);
    },

    formateDat: function (dats, inx) {
      for (let i in dats) {
        let Item = dats[i];
        if (inx) {
          let tmp = [i];
          Item.x = inx.concat(tmp);
        } else {
          Item.x = [i];
        }
        Item.hide = true;
        this.storeArr.push(Item);
        // if(Item.getCompanyPostModules.length > 0){
        // 	  this.formateDat(Item.getCompanyPostModules,Item.x);
        if (Item.children && Item.children.length > 0) {
          this.formateDat(Item.children, Item.x);
        }
      }
    },

    arrEquires: function (arr1, arr2) {
      let eqs = true;
      for (let i in arr1) {
        if (arr1[i] != arr2[i]) {
          eqs = false;
          break;
        }
      }

      return eqs;
    },

    preFmate: function (rows) {
      if (rows.hide) {
        rows.hide = false;
        this.showFormate("open", rows.x);
      } else {
        rows.hide = true;
        this.showFormate("close", rows.x);
      }
    },

    showFormate: function (state, iArr) {
      // iArr 被点击行的 root 数组
      // state 执行 code

      let tempArr = [];
      for (let i in this.storeArr) {
        let item = this.storeArr[i];
        if (state == "init") {
          if (item.x.length == 1) {
            tempArr.push(item);
          }
        } else {
          if (this.arrEquires(iArr, item.x)) {
            if (item.x.length - iArr.length == 1) {
              tempArr.push(item);
            }
          }
        }
      }

      if (state == "open") {
        for (let i in this.showArr) {
          let item = this.showArr[i];
          if (this.arrEquires(iArr, item.x) && iArr.length == item.x.length) {
            this.showArr.splice(parseInt(i) + 1, 0, ...tempArr);
            break;
          }
        }
      } else if (state == "close") {
        let transArr = [];
        for (let i in this.showArr) {
          let toAdd = true;
          for (let j in tempArr) {
            if (this.arrEquires(tempArr[j].x, this.showArr[i].x)) {
              toAdd = false;
              break;
            }
          }
          if (toAdd) {
            transArr.push(this.showArr[i]);
          }
        }

        this.showArr = transArr;
      } else if (state == "init") {
        this.showArr = tempArr;
      }
    },

    goSave: function () {
      let msg = "";
      if (!this.postDats.name) {
        msg = "请填写名称！";
      }

      // console.log("save data = " ,JSON.stringify(this.postDats));

      if (msg) {
        this.$message({
          showClose: true,
          message: msg,
          type: "error",
        });
      } else {
        menuCreate({
          organization: this.postDats,
        })
          .then((response) => {
            let tipCode = response.tipCode;
            let tipMessage = response.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.diaForAdd = false;
              this.$message({
                showClose: true,
                message: "操作成功！",
                type: "success",
              });
              // this.storeArr = [];
              this.initPage();
            }
          })
          .catch((error) => {
            this.diaForAdd = false;
            this.$message({
              showClose: true,
              message: "操作失败！",
              type: "error",
            });
          });
      }
    },

    goRemove: function (dat) {
      this.$confirm('确定要删除 "' + dat.name + '" 节点吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let posts = {
            id: dat.id,
          };
          delDot(posts)
            .then((response) => {
              let tipCode = response.tipCode;
              let tipMessage = response.message || "操作失败";
              if (tipCode == "fail") {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "删除成功！",
                  type: "success",
                });
                // this.storeArr = [];
                this.initPage();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },

    btnTrans: function (state, dat) {
      if (state == "add") {
        this.diaForAdd = true;
        this.diaTitle = "添加";
        if (dat) {
          this.postDats.pId = dat.id;
          this.postDats.name = "";
          this.postDats.id = "";
        } else {
          this.postDats.pId = "";
          this.postDats.name = "";
          this.postDats.id = "";
        }
      } else if (state == "edit") {
        console.log(dat);
        this.diaForAdd = true;
        this.diaTitle = "编辑";
        this.postDats = {
          id: dat.id,
          pId: dat.pId,
          name: dat.name,
        };
      } else if (state == "remove") {
        //  if(dat.getCompanyPostModules.length > 0){
        // if (dat.children.length > 0) {
        //   this.$message({
        //     showClose: true,
        //     message: '该机构下存在子机构，请先删除子机构！',
        //     type: 'info'
        //   });
        // } else {
        this.goRemove(dat);
        // }
      }
    },

    listOrganization: function () {
      let that = this;
      listOrganization(this.param).then((response) => {
        that.tableAllData = response.payload;
        that.filterTableData();
      });
    },

    filterTableData: function () {
      let tableData = this.tableAllData;
      let qName = this.param.name;
      let qParentname = this.param.parentname;
      // 名称查询
      if (!this.isEmpty(qName)) {
        let itemName;
        tableData = tableData.filter(function (item) {
          itemName = item.name || "";

          if (itemName.indexOf(qName) > -1) {
            return true;
          }
          return false;
        });
      }
      // 上级单位查询
      if (!this.isEmpty(qParentname)) {
        let itemParentName;
        tableData = tableData.filter(function (item) {
          itemParentName = item.parent == undefined ? "" : item.parent.name;

          if (itemParentName.indexOf(qParentname) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tableData = tableData;
    },

    initPage: function () {
      // listOrganization(this.param).then(response => {
      //   this.tableData = response.payload;
      //   this.tableAllData = response.payload;
      // });
      this.listOrganization();
    },
  },
  created: function () {
    this.initPage();
  },
};
</script>

<style lang="scss">
.pgemnt-4 {
  padding: 6px 30px;
}

.pgemnt-4 .goDeeper {
  cursor: pointer;
}

.pgemnt-4-dag .el-dialog__header {
  padding: 20px 18px 25px;
}

.pgemnt-4-dag .el-dialog__body {
  padding: 0px 30px;
  margin-bottom: 12px;
}

.pgemnt-4-dag .el-dialog__footer {
  padding-bottom: 30px;
}

.pgemnt-4-dag table {
  width: 100%;
  margin-top: 12px;
}

.pgemnt-4-dag table td {
  padding-bottom: 12px;
}

.pgemnt-4 .inpName {
  text-align: right;
  width: 60px;
  padding-right: 15px;
}

.pgemnt-4 .inpGup {
  margin-bottom: 12px;
  height: 45px;
  background: salmon;
}

.pgemnt-4 .newAdd {
  width: 90px;
}
</style>



// WEBPACK FOOTER //
// sectMent.vue?0f34b32c